var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var convertToServerRegistrationData = function (data) {
    var companyLogo = data.companyLogo, rest = __rest(data, ["companyLogo"]);
    return __assign(__assign({}, rest), { additionalPhoneNumbers: data.phoneNumbers.map(function (ph) { return ph.number.replaceAll(' ', ''); }), phoneNumber: data.mainPhoneNumber.replaceAll(' ', ''), companyDescription: data.compannyInfo, formFile: data.formFile });
};
